import { render, staticRenderFns } from "./InformacionElementos.vue?vue&type=template&id=01fe8920&scoped=true"
import script from "./InformacionElementos.vue?vue&type=script&lang=js"
export * from "./InformacionElementos.vue?vue&type=script&lang=js"
import style0 from "./InformacionElementos.vue?vue&type=style&index=0&id=01fe8920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fe8920",
  null
  
)

export default component.exports